import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { riskApi } from '../../utils/api';
import { RiskDto } from '@api/models/risk/RiskDto';
import { EntityState } from '@api/models/enums/EntityState';

type State = BaseType<RiskDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    nameEn: '',
    state: EntityState.Active,
  },
};

export const riskSlice = baseSlice({
  name: 'risk',
  initialState,
});

export const selectRiskState = (state: RootState) => state.risk.state;
export const selectRisk = (state: RootState) => state.risk.data;
export const riskActions = riskSlice.actions;

export const getRisk = (riskId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return riskApi.getRisk(riskId);
  };

  getItem({
    dispatch,
    actions: riskActions,
    getData: handleGetData,
  });
};
